export default window.WebFont;
